import * as Yup from 'yup';

export const getSignUpSchema = (step: number) => {
  if (step === 1) {
    // Step 1 schema (only fields for step 1)
    return Yup.object().shape({
      fullName: Yup.string().required('Full Name is required'),
      email: Yup.string()
        .email('Invalid email format')
        .matches(/^[a-zA-Z0-9](.*[a-zA-Z0-9])?$/, 'Invalid email format')
        .required('Email is required'),
      contact: Yup.string().matches(
        /^\+?[0-9\s\-()]{7,20}$/,
        'Contact must be a valid phone number',
      ),
      dob: Yup.string(),
      password: Yup.string()
        .min(6, 'Password must be at least 6 characters')
        .matches(
          /^(?=.*[\d!@#$%^&*(),.?":{}|<>]).{6,}$/,
          'Contain at least one number or one special character.',
        )
        .required('Password is required'),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password')], 'Passwords must match')
        .matches(
          /^(?=.*[\d!@#$%^&*(),.?":{}|<>]).{6,}$/,
          'Contain at least one number or one special character.',
        )
        .required('Confirm Password is required'),
    });
  } else if (step === 2) {
    // Step 2 schema (fields for step 2)
    return Yup.object().shape({
      companyName: Yup.string().required('Company Name is required'),
      industryType: Yup.string().required('Industry Type is required'),
      organizationContact: Yup.string().matches(
        /^\+?[0-9\s\-()]{7,20}$/,
        'Contact must be a valid phone number',
      ),
      industrySize: Yup.string().required('Industry Size is required'),
      headquarterAddress: Yup.string().required(
        'Headquarter Address is required',
      ),
    });
  } else {
    return Yup.object();
  }
};
